import React, { useEffect, useState } from 'react';
import { Row, Col, Table, Tooltip, Space, Divider, Typography, Spin, Button } from 'antd';
import { Link } from "react-router-dom";
import { Box, Message, FolderOpen } from 'iconsax-react';
import { useSelector } from "react-redux";

import { getMyEquipmentList } from '../../redux/dashboard/dashboardActions';

const { Text } = Typography;

import ServiceCallDrawer from '../service-calls/ServiceCallDrawer';

const MyEquipmentTable = ({ isAddButtonEnabled }) => {
  const [showServiceCallDrawer, setShowServiceCallDrawer] = useState(false);
  const [equipIdDetail, setEquipIdDetail] = useState(false);
  const [spinStatus, setSpinStatus] = useState(false);

  const { myEquipmentList } = useSelector((state) => state.dashboard);

  useEffect(async () => {

    setSpinStatus(true);
    await getMyEquipmentList({ cardCode: localStorage.getItem('cardCode') });
    setSpinStatus(false);

  }, []);

  const handleShowServiceCallDrawer = (items) => {
    setShowServiceCallDrawer(true);
    setEquipIdDetail(items);
  };

  const handleCloseServiceCallDrawer = () => {
    setShowServiceCallDrawer(false);
  };

  const columns = [
    {
      title: 'Equip ID',
      dataIndex: 'equipId',
      key: 'equipId',
      width: 100,
      fixed: 'left',
      sorter: (a, b) => a.equipId - b.equipId,
      filterSearch: true,
      filters: [...new Set(myEquipmentList?.map(item => item.equipId))].map(val => ({ text: val, value: val })),
      onFilter: (value, record) => record.equipId === value,
      render: (equipId, record) => {
        return (
          <>
            <Link className="hp-w-100 hp-d-block" to={"/equipment-details?serial=" + record?.mfgSerial}>
              <Text className='hp-text-color-primary-2 hp-font-weight-600'>{equipId}</Text>
              <Link className="table-preview-link hp-text-color-primary-2" to={"/equipment-details?serial=" + record?.mfgSerial}><FolderOpen size={14} className='hp-mr-6 hp-text-color-primary-2' />Open</Link>
            </Link>
          </>
        );
      },
    },
    {
      title: 'Equip Name',
      dataIndex: 'equipName',
      key: 'equipName',
      fixed: 'left',
      width: 200,
      sorter: (a, b) => (a.equipName || '').localeCompare(b.equipName || ''),
      filterSearch: true,
      filters: [...new Set(myEquipmentList?.map(item => item.equipName))].map(val => ({ text: val, value: val })),
      onFilter: (value, record) => record.equipName === value,
      render: (equipmentName) => {
        return (
          <Text>{equipmentName}</Text>
        );
      },
    },
    {
      title: 'Item Code',
      dataIndex: 'itemCode',
      key: 'itemCode',
      fixed: 'left',
      width: 100,
      sorter: (a, b) => (a.itemCode || '').localeCompare(b.itemCode || ''),
      filterSearch: true,
      filters: [...new Set(myEquipmentList?.map(item => item.itemCode))].map(val => ({ text: val, value: val })),
      onFilter: (value, record) => record.itemCode === value,
      render: (text) => {
        return (
          <Text>{text}</Text>
        );
      },
    },
    {
      title: 'Mfg Serial',
      dataIndex: 'mfgSerial',
      key: 'mfgSerial',
      width: 100,
      sorter: (a, b) => (a.mfgSerial || '').localeCompare(b.mfgSerial || ''),
      filterSearch: true,
      filters: [...new Set(myEquipmentList?.map(item => item.mfgSerial))].map(val => ({ text: val, value: val })),
      onFilter: (value, record) => record.mfgSerial === value,
    },
    {
      title: 'On Contract',
      dataIndex: 'onContract',
      key: 'onContract',
      width: 100,
      render: (text, record) => <div className={'hp-text-center'}>{text}</div>,
      sorter: (a, b) => (a.onContract || '').localeCompare(b.onContract || ''),
      filterSearch: true,
      filters: [...new Set(myEquipmentList?.map(item => item.onContract))].map(val => ({ text: val, value: val })),
      onFilter: (value, record) => record.onContract === value,
    },
    {
      title: 'Orders',
      dataIndex: 'openOrders',
      key: 'openOrders',
      width: 80,
      render: (text, record) => <div className={'hp-text-center'}>{text}</div>,
      sorter: (a, b) => a.openOrders - b.openOrders,
      filterSearch: true,
      filters: [...new Set(myEquipmentList?.map(item => item.openOrders))].map(val => ({ text: val, value: val })),
      onFilter: (value, record) => record.openOrders === value,
    },
    {
      title: 'Address',
      dataIndex: 'address',
      key: 'address',
      width: 250,
      sorter: (a, b) => (a.address || '').localeCompare(b.address || ''),
      filterSearch: true,
      filters: [...new Set(myEquipmentList?.map(item => item.address))].map(val => ({ text: val, value: val })),
      onFilter: (value, record) => record.address === value,
      render: (address) => {
        return (
          <Tooltip title={address}>
            <Text ellipsis>{address}</Text>
          </Tooltip>
        );
      },
    },
    {
      title: 'Create',
      key: 'create',
      width: 130,
      align: 'center',
      fixed: 'right',
      render: (_, record) => (
        <Space style={{ justifyContent: 'center' }}>
          <Link
            to={isAddButtonEnabled ? `/create-supply-order?mfgSerial=${record.mfgSerial}&serialNum=${record.equipId}` : '#'}
            className={`hp-text-color-primary-2 hp-font-weight-600 ${!isAddButtonEnabled ? 'disabled-link' : ''}`}
            onClick={(e) => !isAddButtonEnabled && e.preventDefault()}
          >
            Supply Order
          </Link>
          <Divider type='vertical' className='hp-mx-4' />
          <a
            className={`hp-cursor-pointer hp-text-color-primary-2 hp-font-weight-600 ${!isAddButtonEnabled ? 'disabled-link' : ''}`}
            onClick={() => isAddButtonEnabled && handleShowServiceCallDrawer(record)}
          >
            Service Call
          </a>
        </Space>
      ),
    },
  ];

  return (
    <>
      <Spin spinning={spinStatus} size="large">
        <Row gutter={[18, 18]}>
          <Col span={24}>
            <Table
              dataSource={myEquipmentList}
              size='small'
              bordered
              columns={columns}
              pagination={{ position: ['bottomCenter'], showSizeChanger: true, pageSizeOptions: ['10', '25', '50', '100'], }}
              scroll={{ x: "1000px" }}
            />
          </Col>
        </Row>
        <ServiceCallDrawer isAddButtonEnabled={isAddButtonEnabled} showServiceCallDrawer={showServiceCallDrawer} handleCloseServiceCallDrawer={handleCloseServiceCallDrawer} mode={'fromDashboard'} serviceCallDetails={equipIdDetail} />
      </Spin>
    </>
  );
};

export default MyEquipmentTable;
